import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  TextField,
  Typography,
  Chip,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  closeTicketAction,
  getCatAction,
  getTicketAction,
} from '../../pages/orders/actions';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectTicketList,
  makeSelectCatList,
} from '../../pages/orders/selectors';
import { SelectorProps, Payload } from '../../pages/orders/interfaces';
import { Store } from '../../redux/reducers';
import handleError from '../../utils/handleError';
import TicketCards from '../../components/Cards/hticketCards';
import { Controller, useForm } from 'react-hook-form';
import {
  FileUploadTicketsRequestBuilder,
  ReplyAllTicketsRequestBuilder,
} from 'client-sdk/src/helpical/categories'; import handleNotfication from '../../utils/handleNotfication';
import Client from 'client-sdk/src/client';
import getTicketById from '../../requests/getTicketById.ts'
import RonadIcons from '../iconComponent';

const useStyles = makeStyles(theme =>
  createStyles({
    loading: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
      justifyContent: 'space-between',
    },
    chatHeader: {
      padding: "16px",
      borderBottomLeftRadius: "0",
      borderBottomRightRadius: "0",
    },
    chatBody: {
      padding: "16px",
      borderRadius: "0",
    },
    chatFooter: {
      border: "1px solid #ededed",
      borderTopLeftRadius: "0",
      borderTopRightRadius: "0",
      padding: "16px",
    },
    mobile: {
      maxWidth: '120%',
      margin: '16px 0',
      '@media (max-width: 480px)': {
        marginTop: '140px',
      },
    },
    uploadInput: {
      display: 'none',
    },
    choosebtn: {
      marginLeft: "1rem",
      span: {
        'nth-child(1)': {
          backgroundColor: '#1976d2',
          color: '#fff',
        },
      },
    },
  })
);

const statusDictionary = {
  OPEN: 'باز',
  CLOSED: 'بسته',
  OWNER_ANSWERED: 'پاسخ ایجادکننده',
};

const translateStatus = status => {
  return statusDictionary[status];
};
const ticketPriority = [
  {
    id: 0,
    name: 'LOW',
    title: 'کم',
    color: '#007644',
    bcolor: '#e8faea',
  },
  {
    id: 1,
    name: 'NORMAL',
    title: 'متوسط',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  },
  {
    id: 2,
    name: 'HIGH',
    title: 'زیاد',
    color: '#FF0000',
    bcolor: '#fffafa',
  },
  {
    id: 3,
    name: 'CRITICAL',
    title: 'اضطراری',
    color: 'maroon',
    bcolor: '#fffafa',
  },
];



const AllHelpicalDetails = props => {
  const params = useParams();
  const [openMsg, setOpenMsg] = useState(false);
  const [file, setFile] = useState<any>('');
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token') || '';
  const [ticketObject, setTicketObject] = useState<object | undefined>(
    undefined
  );


  const { register, control, errors, handleSubmit, setValue, getValues, watch } =
    useForm({
      defaultValues: {
        file: null,
        subject: '1',
        msg: '',
      },
    });

  const classes = useStyles();

  useEffect(() => {
    getTicketById(props.match.params.id).then((response) => {
      setTicketObject(response.data);
    });
  }, []);

  const handleClose = () => {
    props.closeTicketDispatch({
      payload: {
        id: params.id,
      },
      callback: () => {
        getTicketById(props.match.params.id).then((response) => {
          // console.log(response.data);
          setTicketObject(response.data);
        });
      },
    });
  };

  const handleCloseModal = () => {
    setOpenMsg(false);
    setFile(null);
    setValue('file', null);
  };

  const onSubmit = async data => {
    try {
      setLoading(true);
      let fileData = new FormData();
      fileData.append('file', file);
      const makeRequest = new ReplyAllTicketsRequestBuilder()
        .params({})
        .data({
          id: props.match.params.id,
          message: data.msg,
          isReplyAndClose: false,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      if (file) {
        const fileTicketRequest = new FileUploadTicketsRequestBuilder()
          .id(props.match.params.id)
          .data(fileData)
          .build();
        await client.execute(fileTicketRequest);
      }

      handleNotfication('پیام با موفقیت ارسال شدند', 'success');
      setValue('msg', '');
      getTicketById(props.match.params.id).then((response) => {
        // console.log(response.data);
        setTicketObject(response.data);
      });

      // history.push(`/orders/helpical/detail/${props.match.params.id}`);
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }

      handleError(err);
    } finally {
      setFile(null);
      setOpenMsg(false);
      setLoading(false);
      setValue('file', null);
    }
  };
  const handleChangeFileInput = (event: any) => {
    setFile(event.target.files[0]);
  };

  const handleRemoveFile = () => {
    setFile(null);
    setValue('file', null);
  };

  const closeTicket = async data => {
    try {
      setLoading(true);
      let fileData = new FormData();
      fileData.append('file', file);
      const makeRequest = new ReplyAllTicketsRequestBuilder()
        .params({})
        .data({
          id: props.match.params.id,
          message: data.msg,
          isReplyAndClose: true,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      if (file) {
        const fileTicketRequest = new FileUploadTicketsRequestBuilder()
          .id(response.data.id)
          .data(fileData)
          .build();
        await client.execute(fileTicketRequest);
      }

      handleNotfication('تیکت با موفقیت ایجاد شدند', 'success');
      getTicketById(props.match.params.id).then((response) => {
        // console.log(response.data);
        setTicketObject(response.data);
      });
      // window.location.reload();
      // history.push(`/orders/helpical/detail/${props.match.params.id}`);
    } catch (err) {
      console.log(err)
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }

      handleError(err);
    } finally {
      setFile(null);
      setOpenMsg(false);
      setLoading(false);
      setValue('file', null);
    }
  };

  return (
    <React.Fragment>
      {/* <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
            >
              <Grid item md={3} lg={3}>

              </Grid>
              <Grid item md={3} lg={3}>
                <div onClick={history.goBack} style={{ marginRight: '12vw', cursor: "pointer" }}>
                  <Typography variant="button" color="primary">
                    بازگشت
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Grid> */}
      <Typography variant="h6" component="h2" style={{marginBottom: "24px"}}>
        تیکت شماره {ticketObject?.singleTicketsList[0]?.helpicalId}
      </Typography>
      <Paper className={classes.chatHeader}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
        >
          <Grid item md={3} lg={3} style={{ padding: '8px' }}>
            <Typography variant="body1" id="ticketTitle"></Typography>
          </Grid>
          <Grid item md={6} lg={6}>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              spacing={1}
              alignItems="center"
              style={{ padding: '8px' }}
            >
              <Grid item>
                <Typography variant="subtitle2">اولویت:</Typography>
              </Grid>
              <Grid item md={2} lg={2}>
                {/*INSERT PRIORITY DATA*/}
                {ticketObject &&
                  <Chip
                    icon={
                      <RonadIcons name='circleMedium' size={0.6} style={{
                        color: ticketPriority.find((priority) => priority.name === ticketObject?.importance)?.color
                      }}/>
                    }
                    label={ticketPriority.find((priority) => priority.name === ticketObject?.importance)?.title}
                    style={{
                      color: ticketPriority.find((priority) => priority.name === ticketObject?.importance)?.color,
                      backgroundColor: ticketPriority.find((priority) => priority.name === ticketObject.importance)?.bcolor,
                      fontSize: '16px',
                    }}
                  />
                }
              </Grid>
              <Grid item md={3} lg={3}>
                <Typography variant="subtitle2">
                  وضعیت:
                  {/*console.log(ticketObject?.status)*/}
                  {translateStatus(ticketObject?.ticketStatus)}
                </Typography>

                {/*insert status data */}
              </Grid>

              <Grid item>
                <Button
                  variant="outlined"
                  size="medium"
                  component="span"
                  color="default"
                  disabled
                >
                  بستن تیکت
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item md={3} lg={3}>
            {/*INSERT DATE*/}
            <Typography>
              {/*{ticketCreatedDate}
              {jMoment(ticketCreatedDate, 'YYYY-M-D HH:mm:ss').locale('fa')
              .format('HH:mm:ss jYY/jMM/jDD')
             }*/}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Paper className={classes.chatBody}>
        {ticketObject?.singleTicketsList.map(el => {
          return <TicketCards data={el} />;
        })}

      </Paper>
      <Paper className={classes.chatFooter}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container direction="row" alignItems="center">
            <Grid item md={10} lg={10}>
              <Controller
                style={{ width: '100%', padding: '8px' }}
                control={control}
                name="msg"
                rules={{ required: true }}
                as={
                  <TextField
                    style={{ margin: 8 }}
                    placeholder="پیام خود را بنویسید"
                    fullWidth
                    disabled
                    margin="none"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                }
              />

              {/* <TextField
              id="msg"
              label="msg"
              style={{margin: 8}}
              placeholder="پیام خود را بنویسید"
              fullWidth
              margin="none"
              InputLabelProps={{
                disableUnderline: true,
                shrink: true,
              }}
            />
            */}
            </Grid>
            <Grid item md={1} lg={1}>
              <label htmlFor="file" className={classes.choosebtn}>
                <Button variant="contained" size="small" component="span">
                  انتخاب فایل
                </Button>
                <input
                  id="file"
                  type="file"
                  name="file"
                  ref={register}
                  onChange={handleChangeFileInput}
                  className={classes.uploadInput}
                />
              </label>
            </Grid>
            <Grid item md={1} lg={1}>
              <Button
                variant="outlined"
                disabled
                size="small"
                color="primary"
                style={{ marginLeft: '24px' }}
              >
                {loading ? <CircularProgress style={{ height: "30px", width: "30px" }} /> : `ارسال پیام`}
              </Button>

            </Grid>
            {file && (
              <Grid
                style={{
                  textAlign: 'left',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <IconButton
                  aria-label="close"
                  style={{ marginLeft: 'auto' }}
                  onClick={handleRemoveFile}
                >
                  <RonadIcons name="times"  size={0.8}/>
                </IconButton>
                <span style={{ marginTop: '14px' }}>
                  <span style={{ fontWeight: 'bold' }}> {file.name} </span>
                  <span>( {file.size} KB )</span>
                </span>
              </Grid>
            )}
          </Grid>
        </form>
      </Paper>
      <Dialog
        open={openMsg}
        onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        style={{ padding: '16px' }}
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleCloseModal ? (
              <IconButton aria-label="close" onClick={handleCloseModal}>
                <RonadIcons name="times"  size={0.8}/>
              </IconButton>
            ) : null}
          </div>

          <Grid item xs={12} style={{ marginTop: '16px' }}>
            <p style={{ marginTop: '-8px', marginLeft: '46px' }}>
              پاسخ به پیام {props.match.params.id}
            </p>
          </Grid>
          <Divider style={{ width: '100%', marginTop: '16px' }} />
        </DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent style={{ paddingTop: '8px' }}>
            <Controller
              style={{ width: '100%' }}
              control={control}
              name="subject"
              label="موضوع"
              rules={{ required: true }}
              as={
                <TextField
                  style={{ marginTop: '16px', marginBottom: '16px' }}
                  fullWidth
                  variant="outlined"
                  select
                >
                  <MenuItem value={1}>
                    {'پاسخ به پیام بر اساس دستبدی قبل'}
                  </MenuItem>
                </TextField>
              }
            />

            <Controller
              control={control}
              id="msg"
              name="msg"
              rules={{ required: true }}
              as={
                <TextField
                  inputProps={{
                    style: {
                      height: '200px',
                      padding: '0 14px',
                    },
                  }}
                  margin="normal"
                  multiline
                  label="پیام خود را وارد کنید"
                  variant="outlined"
                  fullWidth
                />
              }
            />
            <Grid md={6}>
              <label htmlFor="file" className={classes.choosebtn}>
                <Button variant="contained" size="small" component="span">
                  انتخاب فایل
                </Button>
                <input
                  id="file"
                  type="file"
                  name="file"
                  ref={register}
                  onChange={handleChangeFileInput}
                  className={classes.uploadInput}
                />
              </label>
            </Grid>
            {file && (
              <Grid
                style={{
                  textAlign: 'left',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <IconButton
                  aria-label="close"
                  style={{ marginLeft: 'auto' }}
                  onClick={handleRemoveFile}
                >
                  <RonadIcons name="times" size={0.8}/>
                </IconButton>
                <span style={{ marginTop: '14px' }}>
                  <span style={{ fontWeight: 'bold' }}> {file.name} </span>
                  <span>( {file.size} KB )</span>
                </span>
              </Grid>
            )}

            <Divider style={{ width: '100%', marginTop: '16px' }} />
          </DialogContent>
          <DialogActions>
            <Grid
              container
              spacing={2}
              direction="row-reverse"
              style={{ marginBottom: '8px' }}
            >
              <Button
                type="submit"
                variant="contained"
                size="medium"
                color="primary"
                style={{ marginLeft: '24px' }}
              >
                {`ارسال پاسخ`}
              </Button>
              <Button
                onClick={handleSubmit(closeTicket)}
                variant="outlined"
                size="medium"
                color="primary"
                style={{ marginLeft: '24px' }}
              >
                {`ارسال پاسخ و بستن پیام`}
              </Button>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  catList: makeSelectCatList(),
  msgList: makeSelectTicketList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getCatDispatch: (payload: any) => dispatch(getCatAction(payload)),

    ticketDispatch: (payload: Payload) => dispatch(getTicketAction(payload)),
    closeTicketDispatch: (payload: Payload) =>
      dispatch(closeTicketAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(AllHelpicalDetails);